export default __webpack_public_path__ + "static/media/ic_emergency.119a2ab8.png";